import React, { useState } from 'react'
import { TextArea } from 'is24-corecss'
import './TextInputArea.scss'

export const DEFAULT_LABEL = 'Was ist dir noch wichtig?'
export const DEFAULT_PLACEHOLDER = 'z.B. Stellplatz'
export const DEFAULT_CHARACTERS_LIMIT = 100

interface TextInputAreaProps {
  label?: string
  placeholder?: string
  limit?: number
  initialValue?: string
  onChange?: (value: string) => void
}

const TextInputArea = ({
  label = DEFAULT_LABEL,
  placeholder = DEFAULT_PLACEHOLDER,
  limit = DEFAULT_CHARACTERS_LIMIT,
  initialValue = '',
  onChange,
}: TextInputAreaProps) => {
  const [value, setValue] = useState(initialValue)

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value)
    if (onChange) onChange(event.target.value)
  }

  const labelComponent = label && (
    <span className='input-label align-left' data-testid='text-input-area-label'>
      {label}
    </span>
  )

  return (
    <div className='grid-flex grid-justify-center'>
      <div className='grid-item one-whole text-input-area-container'>
        <TextArea
          id='text-input-area'
          className='text-input-area'
          data-testid='text-input-area'
          label={labelComponent}
          placeholder={placeholder}
          maxLength={limit}
          value={value}
          onChange={handleInputChange}
        />
      </div>
    </div>
  )
}

export default TextInputArea
